import BaseError from "./BaseError";

export default class UnauthorizedError extends BaseError {
  constructor(data) {
    super(data);
    this.name = "UnauthorizedError";
  }
}
